// src/Admin/adminApi.js
const API_BASE = process.env.REACT_APP_API_BASE_URL;
const token = () => localStorage.getItem("token");

// --- util headers ---
function authHeader(tkn) {
  return { Authorization: `Bearer ${tkn || token()}` };
}

// --- Fornitori ---
export async function getFornitori() {
  const res = await fetch(`${API_BASE}/fornitori`, {
    headers: { ...authHeader() },
  });
  return await res.json();
}

export async function createFornitore(data) {
  const res = await fetch(`${API_BASE}/fornitori`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  });
  return await res.json();
}

export async function updateFornitore(id, data, photo = null) {
  let body = JSON.stringify(data);
  if (photo) {
    body = new FormData();
    Object.entries(data).forEach(([key, value]) => body.append(key,
      key === "cover_crop" ? JSON.stringify(value) : value ?? ""));
    body.append("logo", photo);
  }
  const res = await fetch(`${API_BASE}/api/admin/fornitori/${id}`, {
    method: "PUT",
    headers: {
      ...(!photo ? { "Content-Type": "application/json" } : {}),
      ...authHeader(),
    },
    body,
    signal: AbortSignal.timeout(120000),
  });
  const result = await res.json().catch(() => null);
  if (!result || typeof result !== "object") throw new Error("Risposta non valida. Ricarica la scheda per verificare il salvataggio.");
  if (!res.ok) throw new Error(result.error || result.errors?.[0]?.msg || "Errore salvataggio anagrafica");
  if ((photo || data.cover_crop) && !result?.fornitore?.cover_url) throw new Error("Risposta foto non valida. Ricarica la scheda per verificare il salvataggio.");
  return result;
}

export async function deleteFornitore(id) {
  await fetch(`${API_BASE}/fornitori/${id}`, {
    method: "DELETE",
    headers: { ...authHeader() },
  });
}

// --- Servizi (legacy mantenuto) ---
export async function getServizi(idFornitore) {
  const res = await fetch(`${API_BASE}/servizi/fornitore/${idFornitore}`, {
    headers: { ...authHeader() },
  });
  return await res.json();
}

export async function getServizio(id) {
  const res = await fetch(`${API_BASE}/servizi/${id}`, {
    headers: { ...authHeader() },
  });
  return await res.json();
}

export async function createServizio(data) {
  const res = await fetch(`${API_BASE}/servizi`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  });
  return await res.json();
}

export async function updateServizio(id, data) {
  const res = await fetch(`${API_BASE}/servizi/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  });
  return await res.json();
}

export async function deleteServizio(id) {
  await fetch(`${API_BASE}/servizi/${id}`, {
    method: "DELETE",
    headers: { ...authHeader() },
  });
}

// --- Fornitori per città (admin) ---
export async function getFornitoriByCitta(citta, tkn) {
  try {
    const res = await fetch(
      `${API_BASE}/api/admin/fornitori/citta/${encodeURIComponent(citta)}`,
      { headers: authHeader(tkn) },
    );
    if (!res.ok) return res.status === 404 ? [] : [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error("Errore in getFornitoriByCitta:", err);
    return [];
  }
}

export async function getUserInfo(tkn) {
  const res = await fetch(`${API_BASE}/api/auth/userinfo`, {
    headers: authHeader(tkn),
  });
  return await res.json();
}

export async function getServiziRicerca({
  citta,
  lavaggio,
  stiratura,
  token: tkn,
}) {
  try {
    const res = await fetch(
      `${API_BASE}/api/servizi/ricerca?citta=${encodeURIComponent(
        citta,
      )}&lavaggio=${lavaggio}&stiratura=${stiratura}`,
      { headers: authHeader(tkn) },
    );
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error("Errore in getServiziRicerca:", err);
    return [];
  }
}

// --- Fasce orarie (ADMIN & SELF) ---
export async function getFasceOrarie(idFornitore, tkn) {
  const res = await fetch(
    `${API_BASE}/api/admin/fasceorarie/fornitore/${idFornitore}`,
    {
      headers: authHeader(tkn),
    },
  );
  return await res.json();
}
export async function createFasciaOraria(data, tkn) {
  const res = await fetch(`${API_BASE}/api/admin/fasceorarie`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(data),
  });
  return await res.json();
}
export async function updateFasciaOraria(id, payload, tkn) {
  const res = await fetch(`${API_BASE}/api/admin/fasceorarie/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Errore aggiornamento fascia oraria");
  }
  return await res.json();
}
export async function deleteFasciaOraria(id, tkn) {
  await fetch(`${API_BASE}/api/admin/fasceorarie/${id}`, {
    method: "DELETE",
    headers: authHeader(tkn),
  });
}

export async function getMieFasceOrarie(tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/me/fasceorarie`, {
    headers: authHeader(tkn),
  });
  return await res.json();
}
export async function createMiaFasciaOraria(payload, tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/me/fasceorarie`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  return await res.json();
}
export async function updateMiaFasciaOraria(id, payload, tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/me/fasceorarie/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Errore aggiornamento fascia (me)");
  }
  return await res.json();
}
export async function deleteMiaFasciaOraria(id, tkn) {
  await fetch(`${API_BASE}/api/fornitore/me/fasceorarie/${id}`, {
    method: "DELETE",
    headers: authHeader(tkn),
  });
}

// --- Prenotazioni ---
export async function createPrenotazione(data, tkn) {
  const res = await fetch(`${API_BASE}/api/prenotazioni`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Errore nella creazione della prenotazione");
  }
  return await res.json();
}

export async function getFornitoreCompleto(fornitoreId, tkn) {
  const r = await fetch(
    `${API_BASE}/api/fornitori/${fornitoreId}/completo`,
    {
      headers: authHeader(tkn),
    },
  );
  if (!r.ok) throw new Error("Errore caricamento fornitore");
  return await r.json();
}

// --- Users (profilo) ---
export async function getMe() {
  const res = await fetch(`${API_BASE}/api/users/me`, {
    headers: { ...authHeader() },
  });
  return await res.json();
}

export async function updateMe(payload) {
  const res = await fetch(`${API_BASE}/api/users/me`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });
  return await res.json();
}

export async function changeMyPassword(current_password, new_password) {
  const res = await fetch(`${API_BASE}/api/users/me/password`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ current_password, new_password }),
  });
  return await res.json();
}

export async function requestPasswordReset(email) {
  const res = await fetch(`${API_BASE}/api/auth/request-password-reset`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  return await res.json();
}

export async function resetPassword(tkn, new_password) {
  const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: tkn, new_password }),
  });
  return await res.json();
}

// ---- Approvals (Admin) ----
export async function getPendingFornitori(tkn) {
  const res = await fetch(`${API_BASE}/api/admin/fornitori/pending`, {
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Errore caricamento fornitori pending");
  return await res.json();
}

export async function approveFornitore(id, tkn, crop = null, expectedCover = null) {
  const res = await fetch(`${API_BASE}/api/admin/fornitori/${id}/approve`, {
    method: "POST",
    headers: { ...authHeader(tkn), "Content-Type": "application/json" },
    body: JSON.stringify({ cover_crop: crop, expected_cover_url: expectedCover }),
    signal: AbortSignal.timeout(120000),
  });
  const data = await res.json().catch(() => null);
  if (!data || typeof data !== "object") throw new Error("Risposta non valida. Ricarica per verificare l'approvazione.");
  if (!res.ok) throw new Error(data.error || "Errore approvazione fornitore");
  if (!data?.id_fornitore) throw new Error("Risposta non valida. Ricarica per verificare l'approvazione.");
  return data;
}

export async function rejectFornitore(id, tkn) {
  const res = await fetch(`${API_BASE}/api/admin/fornitori/${id}/reject`, {
    method: "POST",
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Errore rifiuto fornitore");
  return await res.json();
}

// (utile per mostrare link admin nell'header)
export async function me(tkn) {
  const res = await fetch(`${API_BASE}/api/auth/userinfo`, {
    headers: authHeader(tkn),
  });
  if (!res.ok) return null;
  return await res.json(); // { id, name, role, status, ... }
}

// --- Catalogo (public/admin) ---
export async function getCatalogoServizi(tkn) {
  const preferred = `${API_BASE}/api/admin/servizi/catalogo`;
  const res = await fetch(preferred, { headers: authHeader(tkn) });
  if (res.ok) return await res.json();

  const res2 = await fetch(`${API_BASE}/api/admin/gestioneservizifornitore`, {
    headers: authHeader(tkn),
  });
  if (!res2.ok) throw new Error("Impossibile caricare il catalogo servizi");
  return await res2.json();
}

/* =========================
   FORNITORE: servizi associati
   ========================= */
export async function getMieiServizi(tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/servizi`, {
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Impossibile caricare i tuoi servizi");
  return await res.json(); // [{servizio_id, descrizione, prezzo, lead_time_min?}]
}

/* =========================
   FORNITORE: catalogo + servizi associati
   ========================= */
export async function getCatalogoServiziFornitore(tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/servizi/catalogo`, {
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Impossibile caricare il catalogo servizi");
  return await res.json(); // [{ id, descrizione, descrizione_estesa, immagine }]
}

/**
 * addMioServizio: compatibile (servizioId, prezzo, token[, lead_time_min|{lead_time_min}])
 */
export async function addMioServizio(servizioId, prezzo, tkn, leadTimeOrOpts) {
  let lead_time_min = null;
  if (typeof leadTimeOrOpts === "number") lead_time_min = leadTimeOrOpts;
  else if (
    leadTimeOrOpts &&
    typeof leadTimeOrOpts === "object" &&
    leadTimeOrOpts.lead_time_min != null
  ) {
    lead_time_min = leadTimeOrOpts.lead_time_min;
  }

  const body = { servizio_id: servizioId, prezzo };
  if (lead_time_min != null) body.lead_time_min = lead_time_min;

  const res = await fetch(`${API_BASE}/api/fornitore/servizi`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("Errore associazione servizio");
  return await res.json();
}

export async function updateMioServizio(servizioId, payload, tkn) {
  // payload: { prezzo?, lead_time_min? }
  const res = await fetch(`${API_BASE}/api/fornitore/servizi/${servizioId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const js = await res.json().catch(() => ({}));
    throw new Error(js.error || "Errore aggiornamento servizio");
  }
  return await res.json();
}

export async function removeMioServizio(servizioId, tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/servizi/${servizioId}`, {
    method: "DELETE",
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Errore rimozione servizio");
  return true;
}

/* ===================================
   ADMIN: gestione servizi dei fornitori
   =================================== */
export async function listFornitori(tkn) {
  const res = await fetch(`${API_BASE}/api/admin/fornitori`, {
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Impossibile caricare fornitori");
  return await res.json(); // [{id, nome, ...}]
}

export async function duplicateFornitore(fornitoreId, payload, tkn) {
  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/duplica`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader(tkn) },
      body: JSON.stringify(payload),
    },
  );
  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js?.error || "Errore duplicazione fornitore");
  return js;
}

export async function getFornitoreServizi(fornitoreId, tkn) {
  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/servizi`,
    {
      headers: authHeader(tkn),
    },
  );
  if (!res.ok) throw new Error("Impossibile caricare servizi del fornitore");
  return await res.json(); // [{servizio_id, descrizione, prezzo, lead_time_min?}]
}

/**
 * addFornitoreServizio: compatibile (fornitoreId, servizioId, prezzo, token[, lead_time_min|{lead_time_min}])
 */
export async function addFornitoreServizio(
  fornitoreId,
  servizioId,
  prezzo,
  tkn,
  leadTimeOrOpts,
) {
  let lead_time_min = null;
  if (typeof leadTimeOrOpts === "number") lead_time_min = leadTimeOrOpts;
  else if (
    leadTimeOrOpts &&
    typeof leadTimeOrOpts === "object" &&
    leadTimeOrOpts.lead_time_min != null
  ) {
    lead_time_min = leadTimeOrOpts.lead_time_min;
  }

  const body = { servizio_id: servizioId, prezzo };
  if (lead_time_min != null) body.lead_time_min = lead_time_min;

  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/servizi`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader(tkn) },
      body: JSON.stringify(body),
    },
  );
  if (!res.ok) throw new Error("Errore associazione (admin)");
  return await res.json();
}

export async function updateFornitoreServizio(
  fornitoreId,
  servizioId,
  payload,
  tkn,
) {
  // payload: { prezzo?, lead_time_min? }
  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/servizi/${servizioId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...authHeader(tkn) },
      body: JSON.stringify(payload),
    },
  );
  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js.error || "Errore aggiornamento (admin)");
  return js;
}

export async function removeFornitoreServizio(fornitoreId, servizioId, tkn) {
  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/servizi/${servizioId}`,
    {
      method: "DELETE",
      headers: authHeader(tkn),
    },
  );
  if (!res.ok) throw new Error("Errore rimozione (admin)");
  return true;
}

/** PROFILO **/
export async function getProfilo(tkn) {
  const res = await fetch(`${API_BASE}/api/profile/me`, {
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Impossibile caricare profilo");
  return await res.json();
}

export async function updateProfilo(payload, tkn) {
  const res = await fetch(`${API_BASE}/api/profile/me`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Impossibile aggiornare profilo");
  return await res.json();
}

/** INDIRIZZI **/
export async function listIndirizzi(tkn) {
  const res = await fetch(`${API_BASE}/api/profile/addresses`, {
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Impossibile caricare indirizzi");
  return await res.json();
}

export async function createIndirizzo(addr, tkn) {
  const res = await fetch(`${API_BASE}/api/profile/addresses`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(addr),
  });
  if (!res.ok) throw new Error("Impossibile creare indirizzo");
  return await res.json();
}

export async function updateIndirizzo(id, addr, tkn) {
  const res = await fetch(`${API_BASE}/api/profile/addresses/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(addr),
  });
  if (!res.ok) throw new Error("Impossibile aggiornare indirizzo");
  return await res.json();
}

export async function deleteIndirizzo(id, tkn) {
  const res = await fetch(`${API_BASE}/api/profile/addresses/${id}`, {
    method: "DELETE",
    headers: authHeader(tkn),
  });
  if (!res.ok) throw new Error("Impossibile eliminare indirizzo");
  return true;
}

export async function listCategorie(tkn) {
  const r = await fetch(`${API_BASE}/api/servizicat/categorieservizi`, {
    headers: authHeader(tkn),
  });
  if (!r.ok) throw new Error("Impossibile caricare le categorie");
  return await r.json();
}

export async function createCategoria(descrizione, tkn) {
  const r = await fetch(`${API_BASE}/api/servizicat/categorieservizi`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify({ descrizione }),
  });
  if (!r.ok) throw new Error("Errore creazione categoria");
  return await r.json();
}

export async function listCatalogoServizi(tkn) {
  const r = await fetch(`${API_BASE}/api/admin/servizi/catalogo`, {
    headers: authHeader(tkn),
  });
  if (!r.ok) throw new Error("Errore caricamento catalogo");
  return await r.json();
}

export async function createServizioCatalogo(payload, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/servizi/catalogo`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error("Errore creazione servizio");
  return await r.json();
}

export async function updateServizioCatalogo(id, payload, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/servizi/catalogo/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error("Errore aggiornamento servizio");
  return await r.json();
}

// === FEES (ADMIN) ===
export async function adminGetFees(fornitoreId, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/fornitori/${fornitoreId}/fees`, {
    headers: authHeader(tkn),
  });
  if (!r.ok) throw new Error("Errore caricamento tariffa");
  return r.json(); // { id, logistics_fee }
}

export async function adminUpdateFees(fornitoreId, logistics_fee, tkn, logistics_fee_exempt) {
  const r = await fetch(`${API_BASE}/api/admin/fornitori/${fornitoreId}/fees`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify({ logistics_fee, logistics_fee_exempt }),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore salvataggio tariffa");
  return js; // { id, logistics_fee }
}

// === FEES (FORNITORE) ===
export async function getMieTariffe(tkn) {
  const r = await fetch(`${API_BASE}/api/fornitore/me/fees`, {
    headers: authHeader(tkn),
  });
  if (!r.ok) throw new Error("Errore caricamento tariffa");
  return r.json(); // { logistics_fee }
}

export async function updateMieTariffe(logistics_fee, tkn) {
  const r = await fetch(`${API_BASE}/api/fornitore/me/fees`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify({ logistics_fee }),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore salvataggio tariffa");
  return js; // { logistics_fee }
}

export async function adminListPromos(tkn) {
  const r = await fetch(`${API_BASE}/api/admin/promos`, {
    headers: authHeader(tkn),
  });
  if (!r.ok) throw new Error("Errore caricamento promozioni");
  return r.json();
}

export async function adminCreatePromoQta(payload, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/promos/promoqta`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore creazione PromoQta");
  return js;
}

export async function adminCreatePromoPaniere(payload, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/promos/paniere`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore creazione Paniere");
  return js;
}

export async function adminTogglePromo(id, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/promos/${id}/toggle`, {
    method: "POST",
    headers: authHeader(tkn),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore toggle promo");
  return js;
}

export async function adminUpdatePromo(id, patch, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/promos/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(patch),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore update promo");
  return js;
}

export async function adminSetPromoSuppliers(id, suppliers, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/promos/${id}/suppliers`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify({ suppliers }),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore salvataggio fornitori promo");
  return js;
}

export async function adminCreatePromoPlain(payload, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/promos/plain`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(tkn),
    },
    body: JSON.stringify(payload),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore creazione promo plain");
  return js;
}

export async function adminGetPromoDetail(id, tkn, opts = {}) {
  const qs = opts.forUser ? `?forUser=${encodeURIComponent(opts.forUser)}` : "";
  const r = await fetch(`${API_BASE}/api/admin/promos/${id}${qs}`, {
    headers: authHeader(tkn),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore caricamento promo");
  return js;
}

export async function adminGetPromo(id, tkn, opts = {}) {
  return adminGetPromoDetail(id, tkn, opts);
}

export async function adminUploadPromoImage(id, file, tkn) {
  const fd = new FormData();
  fd.append("image", file);
  const r = await fetch(`${API_BASE}/api/admin/promos/${id}/image`, {
    method: "POST",
    headers: authHeader(tkn),
    body: fd,
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore upload immagine");
  return js; // { id, image_url }
}

export async function adminDeletePromoImage(id, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/promos/${id}/image`, {
    method: "DELETE",
    headers: authHeader(tkn),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore eliminazione immagine");
  return js; // { id, image_url:null }
}

export async function adminGetReferralConfig() {
  const r = await fetch(`${API_BASE}/api/admin/referral-config`, {
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  });
  if (!r.ok) throw new Error("Errore caricamento referral config");
  return r.json();
}

export async function adminSetReferralConfig(payload) {
  const r = await fetch(`${API_BASE}/api/admin/referral-config`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw new Error(e.error || "Errore salvataggio referral config");
  }
  return r.json();
}

// CLIENTI
export async function getClients(
  tkn,
  {
    q = "",
    page = 1,
    pageSize = 20,
    onlyActive = false,
    includeDeleted = false,
    sortBy = "created_at",
    sortDir = "desc",
  } = {},
) {
  const qs = new URLSearchParams({
    q,
    page: String(page),
    pageSize: String(pageSize),
    onlyActive: onlyActive ? "1" : "0",
    includeDeleted: includeDeleted ? "1" : "0",
    sortBy,
    sortDir,
  });
  const r = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/api/admin/clients?${qs.toString()}`,
    {
      headers: { ...authHeader(tkn) },
    },
  );
  if (!r.ok) throw new Error("Fetch clients failed");
  return r.json();
}

export async function getClientDetail(tkn, id) {
  const r = await fetch(`${API_BASE}/api/admin/clients/${id}`, {
    headers: { ...authHeader(tkn) },
  });
  if (!r.ok) throw new Error("Errore caricamento cliente");
  return r.json();
}

export async function updateClient(tkn, id, payload) {
  const r = await fetch(`${API_BASE}/api/admin/clients/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(tkn),
    },
    body: JSON.stringify(payload),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js?.error || "Errore aggiornamento");
  return js;
}

// --- Cancellazione account cliente (servizio unico lato server) ---
async function jsonOrThrow(r, fallbackMessage) {
  const js = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(js?.error || fallbackMessage);
    err.code = js?.code;
    err.blockers = js?.blockers;
    throw err;
  }
  return js;
}

export async function getClientDeletionPreview(tkn, id) {
  const r = await fetch(`${API_BASE}/api/admin/clients/${id}/delete-preview`, {
    headers: { ...authHeader(tkn) },
  });
  return jsonOrThrow(r, "Errore anteprima cancellazione");
}

export async function deleteClientAccount(tkn, id, { confirmEmail, reason, notifyUser = false }) {
  const r = await fetch(`${API_BASE}/api/admin/clients/${id}/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify({
      confirm_email: confirmEmail,
      reason,
      notify_user: !!notifyUser,
    }),
  });
  return jsonOrThrow(r, "Errore cancellazione cliente");
}

export async function zeroClientWallet(tkn, id, reason) {
  const r = await fetch(`${API_BASE}/api/admin/clients/${id}/wallet/zero`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify({ reason }),
  });
  return jsonOrThrow(r, "Errore azzeramento saldo wallet");
}

export async function getDeletionsStripePending(tkn) {
  const r = await fetch(`${API_BASE}/api/admin/client-deletions/stripe-pending`, {
    headers: { ...authHeader(tkn) },
  });
  return jsonOrThrow(r, "Errore caricamento cancellazioni Stripe");
}

export async function getClientOrders(
  tkn,
  id,
  { page = 1, pageSize = 20 } = {},
) {
  const url = new URL(`${API_BASE}/api/admin/clients/${id}/orders`);
  url.searchParams.set("page", String(page));
  url.searchParams.set("pageSize", String(pageSize));
  const r = await fetch(url, { headers: { ...authHeader(tkn) } });
  if (!r.ok) throw new Error("Errore caricamento ordini");
  return r.json();
}

// Cerca clienti (per il picker) usando la route admin esistente
export async function adminSearchClients({
  q = "",
  page = 1,
  pageSize = 200,
  onlyActive = true,
} = {}) {
  const params = new URLSearchParams({
    q,
    page: String(page),
    pageSize: String(pageSize),
    onlyActive: onlyActive ? "1" : "0",
    sortBy: "name",
    sortDir: "asc",
  });

  const r = await fetch(`${API_BASE}/api/admin/clients?${params.toString()}`, {
    headers: { ...authHeader() },
    credentials: "include",
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new Error(js?.error || "Errore caricamento clienti");
  }

  const items = Array.isArray(js.items) ? js.items : [];
  // normalizzazione per la UI del picker
  return items.map((u) => ({
    id: u.id,
    name: u.name || null,
    email: u.email || null,
    label: u.name
      ? `${u.name} · ${u.email || ""}`
      : u.email || `Utente #${u.id}`,
  }));
}

// Associa una promo a una lista di clienti (sovrascrive l'insieme)
// retro-compatibile: terzo argomento tkn è opzionale
export async function adminSetPromoCustomers(promoId, customers, tkn) {
  const payload = {
    customers: Array.isArray(customers)
      ? customers.map(Number).filter(Number.isFinite)
      : [],
  };

  const r = await fetch(`${API_BASE}/api/admin/promos/${promoId}/customers`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  const js = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new Error(js?.error || "Errore salvataggio clienti promo");
  }
  return js;
}

/* ========= FIX 401 AREA ========= */
export async function adminUpdateQtaRule(ruleId, payload) {
  const r = await fetch(`${API_BASE}/api/admin/promos/promoqta/${ruleId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    const msg =
      (await r.text().catch(() => "")) || "Errore aggiornamento regola QTA";
    throw new Error(msg);
  }
  return r.json();
}

export async function adminUpdateBasket(basketId, payload) {
  const r = await fetch(`${API_BASE}/api/admin/promos/paniere/${basketId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    const msg =
      (await r.text().catch(() => "")) || "Errore aggiornamento paniere";
    throw new Error(msg);
  }
  return r.json();
}

export async function adminSetBasketItems(basketId, items) {
  const r = await fetch(
    `${API_BASE}/api/admin/promos/paniere/${basketId}/items`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify({ items }),
    },
  );
  if (!r.ok) {
    const msg =
      (await r.text().catch(() => "")) || "Errore salvataggio items paniere";
    throw new Error(msg);
  }
  return r.json();
}
/* ======== /FIX 401 AREA ======== */
// ===== Admin: gestione profilo/indirizzi di un altro utente =====
export async function adminGetUserProfile(userId, tkn) {
  const r = await fetch(`${API_BASE}/api/profile/admin/${userId}`, {
    headers: { ...authHeader(tkn) },
  });
  if (!r.ok) throw new Error("Errore caricamento profilo utente (admin)");
  return r.json();
}

export async function adminUpdateUserProfile(userId, payload, tkn) {
  const r = await fetch(`${API_BASE}/api/profile/admin/${userId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok)
    throw new Error(js?.error || "Errore aggiornamento profilo (admin)");
  return js;
}

export async function adminListUserAddresses(userId, tkn) {
  const r = await fetch(`${API_BASE}/api/profile/admin/${userId}/addresses`, {
    headers: { ...authHeader(tkn) },
  });
  if (!r.ok) throw new Error("Errore caricamento indirizzi (admin)");
  return r.json();
}

export async function adminCreateUserAddress(userId, addr, tkn) {
  const r = await fetch(`${API_BASE}/api/profile/admin/${userId}/addresses`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(addr),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js?.error || "Errore creazione indirizzo (admin)");
  return js;
}

export async function adminUpdateUserAddress(userId, addrId, addr, tkn) {
  const r = await fetch(
    `${API_BASE}/api/profile/admin/${userId}/addresses/${addrId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...authHeader(tkn) },
      body: JSON.stringify(addr),
    },
  );
  const js = await r.json().catch(() => ({}));
  if (!r.ok)
    throw new Error(js?.error || "Errore aggiornamento indirizzo (admin)");
  return js;
}

export async function adminDeleteUserAddress(userId, addrId, tkn) {
  const r = await fetch(
    `${API_BASE}/api/profile/admin/${userId}/addresses/${addrId}`,
    {
      method: "DELETE",
      headers: { ...authHeader(tkn) },
    },
  );
  if (!r.ok) {
    const txt = await r.text().catch(() => "");
    throw new Error(txt || "Errore eliminazione indirizzo (admin)");
  }
  return true;
}

// USER: promo personali
export async function getMyPromos(tkn) {
  const r = await fetch(`${API_BASE}/api/me/promos`, {
    headers: { ...authHeader(tkn) },
  });
  if (!r.ok) throw new Error("Errore caricamento promo personali");
  return r.json();
}

export async function adminGetUserPromos(userId, tkn) {
  const r = await fetch(`${API_BASE}/api/admin/users/${userId}/promos`, {
    headers: { ...authHeader(tkn) },
  });
  if (!r.ok) throw new Error("Errore caricamento promo utente");
  return r.json();
}

export async function adminUpsertPromoCustomerValidity(
  promoId,
  userId,
  payload,
  token,
) {
  const res = await fetch(
    `${API_BASE}/api/admin/promos/${promoId}/customers/${userId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload), // { valid_days? , valid_from? , valid_until? }
    },
  );
  const data = await res.json();
  if (!res.ok || data?.error)
    throw new Error(data?.error || "Errore salvataggio validità");
  return data;
}

// Wallet: saldo + movimenti
export async function getMyWallet(token, { forUserId } = {}) {
  const params = new URLSearchParams();
  if (forUserId != null) params.set("userId", String(forUserId));

  const r = await fetch(
    `${API_BASE}/api/wallet/me${
      params.toString() ? "?" + params.toString() : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  const js = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new Error(js.error || "Errore caricamento wallet");
  }
  return js;
}

// Wallet: offerte ricarica (utente)
export async function getWalletTopupOffers(token) {
  const r = await fetch(`${API_BASE}/api/wallet/topup/offers`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore caricamento offerte ricarica");
  return js; // { offers: [...] }
}

// Wallet: crea sessione di ricarica Stripe
export async function createWalletTopupSession(
  amount,
  token,
  { forUserId, offerId } = {},
) {
  const r = await fetch(`${API_BASE}/api/wallet/topup/session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      amount,
      ...(offerId != null ? { offerId } : { amount }),
      ...(forUserId != null ? { userId: forUserId } : {}),
    }),
  });

  const js = await r.json().catch(() => ({}));
  if (!r.ok || !js.url) {
    throw new Error(js.error || "Errore creazione sessione ricarica");
  }
  return js; // { url }
}

export async function adminGetUserPromoRedemptions(
  userId,
  tkn,
  { page = 1, pageSize = 20 } = {},
) {
  const url = new URL(
    `${API_BASE}/api/admin/users/${userId}/promo-redemptions`,
  );
  url.searchParams.set("page", String(page));
  url.searchParams.set("pageSize", String(pageSize));

  const r = await fetch(url, { headers: authHeader(tkn) });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore caricamento utilizzi promo");
  return js; // { page, pageSize, total, items: [...] }
}

export async function adminListReferralUses(tkn, { limit = 200 } = {}) {
  const r = await fetch(
    `${API_BASE}/api/admin/referrals/uses?limit=${encodeURIComponent(limit)}`,
    {
      headers: authHeader(tkn),
    },
  );
  const js = await r.json().catch(() => ({}));
  if (!r.ok)
    throw new Error(js.error || "Errore caricamento utilizzi referral");
  return Array.isArray(js) ? js : [];
}

// --- ZONE (ADMIN): comuni <-> fornitori ---
export async function adminListZones(tkn, { q = "" } = {}) {
  const qs = q ? `?q=${encodeURIComponent(q)}` : "";
  const r = await fetch(`${API_BASE}/api/admin/zones${qs}`, {
    headers: authHeader(tkn),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore caricamento zone");
  return Array.isArray(js) ? js : [];
}

export async function adminGetZoneSuppliers(comune, tkn) {
  const r = await fetch(
    `${API_BASE}/api/admin/zones/by-comune/${encodeURIComponent(comune)}`,
    { headers: authHeader(tkn) },
  );
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore caricamento fornitori comune");
  return js; // { linked, unlinked, comune_norm }
}

export async function adminAddZoneSupplier(comune, payload, tkn) {
  const r = await fetch(
    `${API_BASE}/api/admin/zones/by-comune/${encodeURIComponent(comune)}/add`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader(tkn) },
      body: JSON.stringify(payload), // { fornitoreId, comune, provincia, cap }
    },
  );
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore associazione fornitore");
  return js;
}

export async function adminRemoveZoneSupplier(comune, fornitoreId, tkn) {
  const r = await fetch(
    `${API_BASE}/api/admin/zones/by-comune/${encodeURIComponent(
      comune,
    )}/remove/${encodeURIComponent(String(fornitoreId))}`,
    { method: "DELETE", headers: authHeader(tkn) },
  );
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore disassociazione fornitore");
  return js;
}

export async function adminReplaceZoneSuppliers(comune, payload, tkn) {
  const r = await fetch(
    `${API_BASE}/api/admin/zones/by-comune/${encodeURIComponent(comune)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader(tkn) },
      body: JSON.stringify(payload), // { comune, provincia, cap, suppliers:[...] }
    },
  );
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore salvataggio set fornitori");
  return js;
}

export async function adminDeleteZone(comune, tkn) {
  const r = await fetch(
    `${API_BASE}/api/admin/zones/by-comune/${encodeURIComponent(comune)}`,
    { method: "DELETE", headers: authHeader(tkn) },
  );
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore eliminazione comune");
  return js;
}

export async function adminGetWelcomeConfig() {
  const r = await fetch(`${API_BASE}/api/admin/welcome-config`, {
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  });
  if (!r.ok) throw new Error("Errore caricamento welcome config");
  return r.json();
}

export async function adminSetWelcomeConfig(payload) {
  const r = await fetch(`${API_BASE}/api/admin/welcome-config`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw new Error(e.error || "Errore salvataggio welcome config");
  }
  return r.json();
}

export async function adminGetPromoStats({
  days = 90,
  expiringDays = 7,
  supplierId = null,
  promoId = null,
  noPromo = false,
  city = "",
  province = "",
  q = "",
  page = 1,
  pageSize = 50,
} = {}) {
  const params = new URLSearchParams();
  params.set("days", String(days));
  params.set("expiringDays", String(expiringDays));

  if (supplierId) params.set("supplierId", String(supplierId));
  if (promoId) params.set("promoId", String(promoId));
  if (noPromo) params.set("noPromo", "1");
  if (q) params.set("q", q);

  const c = String(city || "").trim();
  const pr = String(province || "").trim();
  if (c) params.set("city", c);
  if (pr) params.set("province", pr);

  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  const r = await fetch(
    `${API_BASE}/api/admin/promos/stats?${params.toString()}`,
    {
      headers: authHeader(),
      credentials: "include",
    },
  );

  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore caricamento stats promo");
  return js;
}

export async function adminAssignPromoToCustomers(promoId, payload) {
  const res = await fetch(`${API_BASE}/api/admin/promos/${promoId}/assign`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(), // JWT
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Errore assegnazione promo");
  return data;
}

export async function adminListPromoAssignedTemplates() {
  const res = await fetch(
    `${API_BASE}/api/admin/promos/templates?kind=promo_assigned`,
    {
      headers: authHeader(),
    },
  );
  if (!res.ok) throw new Error("Errore caricamento templates promo");
  return res.json();
}

export async function adminListPromosLite() {
  const r = await fetch(`${API_BASE}/api/admin/promos/options`, {
    headers: authHeader(),
    credentials: "include",
  });

  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || "Errore caricamento opzioni promo");
  return js;
}

// --- Chiusure fornitore (SELF) ---
export async function getMieChiusure(tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/me/chiusure`, {
    headers: authHeader(tkn),
  });
  const js = await res.json().catch(() => []);
  if (!res.ok) throw new Error(js?.error || "Errore caricamento chiusure");
  return Array.isArray(js) ? js : [];
}

export async function createMiaChiusura(payload, tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/me/chiusure`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js?.error || "Errore creazione chiusura");
  return js;
}

export async function updateMiaChiusura(id, payload, tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/me/chiusure/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader(tkn) },
    body: JSON.stringify(payload),
  });
  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js?.error || "Errore aggiornamento chiusura");
  return js;
}

export async function deleteMiaChiusura(id, tkn) {
  const res = await fetch(`${API_BASE}/api/fornitore/me/chiusure/${id}`, {
    method: "DELETE",
    headers: authHeader(tkn),
  });
  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js?.error || "Errore eliminazione chiusura");
  return js;
}

// --- Chiusure fornitore (ADMIN) ---
export async function adminGetChiusureFornitore(fornitoreId, tkn) {
  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/chiusure`,
    { headers: authHeader(tkn) },
  );
  const js = await res.json().catch(() => []);
  if (!res.ok) throw new Error(js?.error || "Errore caricamento chiusure");
  return Array.isArray(js) ? js : [];
}

export async function adminCreateChiusuraFornitore(fornitoreId, payload, tkn) {
  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/chiusure`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader(tkn) },
      body: JSON.stringify(payload),
    },
  );
  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js?.error || "Errore creazione chiusura");
  return js;
}

export async function adminUpdateChiusuraFornitore(
  fornitoreId,
  id,
  payload,
  tkn,
) {
  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/chiusure/${id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...authHeader(tkn) },
      body: JSON.stringify(payload),
    },
  );
  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js?.error || "Errore aggiornamento chiusura");
  return js;
}

export async function adminDeleteChiusuraFornitore(fornitoreId, id, tkn) {
  const res = await fetch(
    `${API_BASE}/api/admin/fornitori/${fornitoreId}/chiusure/${id}`,
    {
      method: "DELETE",
      headers: authHeader(tkn),
    },
  );
  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js?.error || "Errore eliminazione chiusura");
  return js;
}

export async function listAddressOptions(token) {
  const res = await fetch(`${API_BASE}/api/profile/me/address-options`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await res.json().catch(() => []);
  if (!res.ok) {
    throw new Error(data?.error || "Errore caricamento indirizzi disponibili");
  }
  return Array.isArray(data) ? data : [];
}

export async function adminListOrganizations(token) {
  const res = await fetch(`${API_BASE}/api/admin/organizations`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => []);
  if (!res.ok)
    throw new Error(data?.error || "Errore caricamento organizzazioni");
  return data;
}

export async function adminGetOrganizationDetail(orgId, token) {
  const res = await fetch(`${API_BASE}/api/admin/organizations/${orgId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok)
    throw new Error(
      data?.error || "Errore caricamento dettaglio organizzazione",
    );
  return data;
}

export async function adminCreateOrganization(payload, token) {
  const res = await fetch(`${API_BASE}/api/admin/organizations`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok)
    throw new Error(data?.error || "Errore creazione organizzazione");
  return data;
}

export async function adminUpdateOrganization(orgId, payload, token) {
  const res = await fetch(`${API_BASE}/api/admin/organizations/${orgId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok)
    throw new Error(data?.error || "Errore aggiornamento organizzazione");
  return data;
}

export async function adminCreateOrganizationAddress(orgId, payload, token) {
  const res = await fetch(
    `${API_BASE}/api/admin/organizations/${orgId}/addresses`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Errore creazione indirizzo hub");
  return data;
}

export async function adminUpdateOrganizationAddress(
  addressId,
  payload,
  token,
) {
  const res = await fetch(
    `${API_BASE}/api/admin/organization-addresses/${addressId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok)
    throw new Error(data?.error || "Errore aggiornamento indirizzo hub");
  return data;
}

export async function adminAddOrganizationMember(orgId, payload, token) {
  const res = await fetch(
    `${API_BASE}/api/admin/organizations/${orgId}/members`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Errore associazione cliente");
  return data;
}

export async function adminRemoveOrganizationMember(orgId, userId, token) {
  const res = await fetch(
    `${API_BASE}/api/admin/organizations/${orgId}/members/${userId}`,
    {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Errore rimozione cliente");
  return data;
}

// ===============================
// FORNITORE PROFILE REQUESTS
// ===============================

export async function getMySupplierProfile(token) {
  const res = await fetch(`${API_BASE}/api/fornitore/me/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(data?.error || "Errore caricamento profilo fornitore");
  }
  return data;
}

export async function submitMySupplierProfileRequest({ nome, file }, token) {
  const fd = new FormData();
  if (nome != null) fd.append("nome", nome);
  if (file) fd.append("logo", file);

  const res = await fetch(`${API_BASE}/api/fornitore/me/profile-request`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: fd,
  });

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(data?.error || "Errore invio richiesta modifica fornitore");
  }
  return data;
}

export async function adminListSupplierProfileRequests(token) {
  const res = await fetch(
    `${API_BASE}/api/fornitore/me/admin/profile-requests`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(
      data?.error || "Errore caricamento richieste profilo fornitore",
    );
  }
  return Array.isArray(data) ? data : [];
}

export async function adminApproveSupplierProfileRequest(id, token, crop = null, expectedCover = null) {
  const res = await fetch(
    `${API_BASE}/api/fornitore/me/admin/profile-requests/${id}/approve`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cover_crop: crop, expected_cover_url: expectedCover }),
      signal: AbortSignal.timeout(120000),
    },
  );

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(data?.error || "Errore approvazione richiesta");
  }
  if (!data?.request?.id) throw new Error("Risposta non valida. Ricarica per verificare l'approvazione.");
  return data;
}

export async function adminRejectSupplierProfileRequest(id, token) {
  const res = await fetch(
    `${API_BASE}/api/fornitore/me/admin/profile-requests/${id}/reject`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(data?.error || "Errore rifiuto richiesta");
  }
  return data;
}

async function adminJson(url, token, options = {}) {
  const res = await fetch(url, {
    method: options.method || "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
    body: options.body != null ? JSON.stringify(options.body) : undefined,
  });

  let data = null;
  const text = await res.text();
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (_) {
      data = null;
    }
  }

  if (!res.ok) {
    throw new Error(data?.error || "Errore richiesta API");
  }

  return data;
}

/* =========================================================================
 * ORGANIZZAZIONI -> FORNITORI OPTIONS
 * ========================================================================= */

export async function adminListOrganizationSupplierOptions(token) {
  const items = await listFornitori(token);
  return Array.isArray(items) ? items : [];
}

/* =========================================================================
 * ORGANIZZAZIONI -> FASCE DEDICATE
 * ========================================================================= */

export async function adminCreateOrganizationTimeSlot(orgId, payload, token) {
  return adminJson(
    `${API_BASE}/api/admin/organizations/${orgId}/time-slots`,
    token,
    {
      method: "POST",
      body: payload,
    },
  );
}

export async function adminUpdateOrganizationTimeSlot(
  orgId,
  slotId,
  payload,
  token,
) {
  return adminJson(
    `${API_BASE}/api/admin/organizations/${orgId}/time-slots/${slotId}`,
    token,
    {
      method: "PUT",
      body: payload,
    },
  );
}

export async function adminDeleteOrganizationTimeSlot(orgId, slotId, token) {
  return adminJson(
    `${API_BASE}/api/admin/organizations/${orgId}/time-slots/${slotId}`,
    token,
    {
      method: "DELETE",
    },
  );
}

export async function resolveOrganizationContext(payload, token) {
  const res = await fetch(`${API_BASE}/api/organizations/resolve-context`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || "Errore risoluzione contesto organizzazione");
  }
  return data;
}

export async function getOrganizationSchedule(orgId, token) {
  const res = await fetch(`${API_BASE}/api/organizations/${orgId}/schedule`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || "Errore caricamento fasce organizzazione");
  }
  return data;
}

export async function getHubAddressSchedule(addressId, token) {
  const res = await fetch(
    `${API_BASE}/api/organizations/addresses/${addressId}/schedule`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || "Errore caricamento fasce hub");
  }
  return data;
}

// SAVE ALL
export async function saveOrganizationAll(payload, token) {
  const res = await fetch(`${API_BASE}/api/admin/organizations/save-all`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || "Errore salvataggio organizzazione");
  }

  return data;
}

// SEARCH CLIENTS (autocomplete)
export async function searchCustomers(query, token) {
  const res = await fetch(
    `${API_BASE}/api/admin/organizations/customers/search?q=${encodeURIComponent(
      query
    )}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || "Errore ricerca clienti");
  }

  return data;
}
// --- Richieste cancellazione account ---
export async function adminListDeletionRequests(token) {
  const res = await fetch(`${API_BASE}/api/admin/deletion-requests`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || "Errore caricamento richieste cancellazione");
  return Array.isArray(data) ? data : [];
}

export async function adminApproveDeletionRequest(id, token) {
  const res = await fetch(`${API_BASE}/api/admin/deletion-requests/${id}/approve`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || "Errore approvazione cancellazione");
  return data;
}

export async function adminRejectDeletionRequest(id, adminNote, token) {
  const res = await fetch(`${API_BASE}/api/admin/deletion-requests/${id}/reject`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ admin_note: adminNote }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || "Errore rifiuto cancellazione");
  return data;
}

// --- Richieste export dati (GDPR Art. 20) ---
export async function adminListDataExportRequests(token) {
  const res = await fetch(`${API_BASE}/api/admin/data-export-requests`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || "Errore caricamento richieste export");
  return Array.isArray(data) ? data : [];
}

export async function adminProcessDataExportRequest(id, token) {
  const res = await fetch(`${API_BASE}/api/admin/data-export-requests/${id}/process`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || "Errore elaborazione export");
  return data;
}
